import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideMessage } from "Store/Reducer/common.slice";

/**
 * Matches fxbazzar_frontend bar colors; icon rules adjusted for mobile:
 * - Bar: blue default; `successOrder` adds green bar (`redux-toast--green`).
 * - Icon: green check for `success` and `successOrder` (trade / order success from API).
 *   Other variants keep red `info` (errors, generic messages).
 * - Auto-hide 6s like the old app.
 */
export default function GlobalReduxToast() {
  const { showMessage, message, varient } = useSelector((s) => s.common);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!showMessage) return undefined;
    const t = window.setTimeout(() => dispatch(hideMessage()), 6000);
    return () => window.clearTimeout(t);
  }, [showMessage, dispatch]);



  if (!showMessage) return null;

  const isSuccessOrder = varient === "successOrder";
  const showSuccessIcon = varient === "success" || varient === "successOrder";

  const rootClass = [
    "redux-toast",
    isSuccessOrder ? "redux-toast--green" : "",
    "redux-toast--show",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass} id="toast_custom" role="status" aria-live="polite">
      <div className="redux-toast__icon" id="img" aria-hidden>
        <span
          className={`material-icons-outlined ${
            showSuccessIcon ? "redux-toast__symbol--success" : "redux-toast__symbol--alert"
          }`}
        >
          {showSuccessIcon ? "check_circle_outline" : "info"}
        </span>
      </div>
      <div className="redux-toast__msg" id="desc">
        {message != null ? String(message) : ""}
      </div>
    </div>
  );
}
